import React, { memo } from 'react';
import { Box, Container, CssBaseline, Typography } from '@mui/material';
import LoginForm, { ILoginForm } from '../LoginForm';
import { LoginText } from '../constants';

interface ILoginProps {
  onSubmit: (values: ILoginForm) => void;
}
const LoginWrapper = memo<ILoginProps>(({ onSubmit }) => (
  <Container component="main" maxWidth="xs">
    <CssBaseline />
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography component="h1" variant="h5">
        {LoginText.TITLE}
      </Typography>
      <LoginForm onSubmit={onSubmit} />
    </Box>
  </Container>
));

export default LoginWrapper;
